import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Supabase credentials missing. Database features will be disabled.");
}

// iOS Safari's Web Locks API orphans locks when tabs are backgrounded,
// causing a 5s timeout then AbortError that kills all Supabase queries.
// Bypassing with a no-op lock is safe for a single-tab SPA.
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder',
  {
    auth: {
      lock: async (_name: string, _acquireTimeout: number, fn: () => Promise<unknown>) => fn(),
    },
  }
);
